"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refineIdea = refineIdea;
const dist_1 = require("../../core/dist");
const aiSummarization_1 = require("./utils/aiSummarization");
const SYSTEM_PROMPT = `You are an AI assistant embedded in REslava Loom, a document-driven workflow system.
Your task: read this idea document and produce an improved version — sharpen the problem statement, clarify the concept, fill in weak sections.
If the Additional Context contains a locked requirements (req) doc — sections ✅ Included / ❌ Excluded / ⛓ Constraints, each item prefixed with an inline-code \`IN\`/\`EX\`/\`C\` id — treat every ❌ Excluded item and ⛓ Constraint as a HARD BOUNDARY: do not (re)introduce excluded scope.
Respond with exactly this format — nothing else before or after:

TITLE: <improved or unchanged title>

## Problem
<what pain or gap this idea addresses>

## Idea
<the core concept in 2-3 sentences>

## Why now
<what makes this worth pursuing>

## Open questions
<what needs to be answered before committing to a design>

## Next step
<design | spike | discard>`;
async function refineIdea(input, deps) {
    const doc = await deps.loadDoc(input.filePath);
    const content = input.extraContext
        ? `## Additional Context\n\n${input.extraContext}\n\n---\n\n${doc.content}`
        : doc.content;
    const messages = (0, aiSummarization_1.buildSummarizationMessages)(SYSTEM_PROMPT, `idea document titled "${doc.title}"`, content);
    const reply = await deps.aiClient.complete(messages);
    const { title, body } = (0, aiSummarization_1.parseTitleAndBody)(reply);
    const refined = (0, dist_1.ideaReducer)(doc, { type: 'REFINE_IDEA' });
    const updated = {
        ...refined,
        title,
        content: `# ${title}\n\n${body}`,
    };
    await deps.saveDoc(updated, input.filePath);
    return { filePath: input.filePath, version: updated.version };
}
